import React from 'react'

export default class IconsMainNavTracking extends React.Component {
    render() {
        let className = 'icons-icon'

        return (
            <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
                className={className}
                style={this.props.style}
            >
                <g clipPath='url(#clip0_45_191)'>
                    <path
                        d='M8.00001 14.6666C11.6819 14.6666 14.6667 11.6819 14.6667 7.99998C14.6667 4.31808 11.6819 1.33331 8.00001 1.33331C4.31811 1.33331 1.33334 4.31808 1.33334 7.99998C1.33334 11.6819 4.31811 14.6666 8.00001 14.6666Z'
                        stroke='#646464'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M8.00001 1.33331C6.28817 3.13075 5.33334 5.51781 5.33334 7.99998C5.33334 10.4822 6.28817 12.8692 8.00001 14.6666C9.71185 12.8692 10.6667 10.4822 10.6667 7.99998C10.6667 5.51781 9.71185 3.13075 8.00001 1.33331Z'
                        stroke='#646464'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M1.33334 8H14.6667'
                        stroke='#646464'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </g>
                <defs>
                    <clipPath id='clip0_45_191'>
                        <rect width='16' height='16' fill='white' />
                    </clipPath>
                </defs>
            </svg>
        )
    }
}
